import ArtVsArtist from './ArtVsArtist'

export default ArtVsArtist
